import Styled from "styled-components";

export interface ContainerProps {
  $size?: string;
}

export const Container = Styled.img<ContainerProps>`
  display: block;
  height: ${(props) => props.$size || "100%"};
`;
